function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useCallback, useRef, useState } from "react";
export function useModalManager() {
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    stack = _useState2[0],
    setStack = _useState2[1];
  const _useState3 = useState("none"),
    _useState4 = _slicedToArray(_useState3, 2),
    action = _useState4[0],
    setAction = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  const nextId = useRef(0);
  const beforeCloseCallbacks = useRef(new Map());
  const generateId = useCallback(() => {
    return `modal-${nextId.current++}`;
  }, []);
  const updateModalStack = useCallback(newStack => {
    return newStack.map((modal, index) => _objectSpread(_objectSpread({}, modal), {}, {
      index,
      isOpen: index === newStack.length - 1
    }));
  }, []);
  const canClose = useCallback(id => {
    const callback = beforeCloseCallbacks.current.get(id);
    return callback ? callback() : true;
  }, []);
  const closeById = useCallback(id => {
    let wasClosed = false;
    setStack(prev => {
      const modal = prev.find(m => m.id === id);
      if (!modal) {
        console.error(`Modal with ID "${id}" not found, and cant be closed`);
        return prev;
      }
      if (!canClose(id)) {
        return prev;
      }
      wasClosed = true;
      beforeCloseCallbacks.current.delete(id);
      const newStack = prev.filter(m => m.id !== id);
      setAction("pop");
      return updateModalStack(newStack);
    });
    return wasClosed;
  }, [updateModalStack, canClose]);
  const closeCurrent = useCallback(id => {
    let wasClosed = false;
    setStack(prev => {
      const newStack = prev.filter(m => m.id !== id);
      setAction("pop");
      return updateModalStack(newStack);
    });
    return wasClosed;
  }, [updateModalStack, canClose]);
  const open = useCallback((component, props, options) => {
    const id = (options === null || options === void 0 ? void 0 : options.id) || generateId();
    return new Promise(async resolve => {
      let actualComponent;
      const isLazyImport = typeof component === "function" && !component.prototype;
      if (isLazyImport) {
        setIsLoading(true);
        try {
          const module = await component();
          actualComponent = module.default;
        } catch (error) {
          setIsLoading(false);
          throw error;
        }
        setIsLoading(false);
      } else {
        actualComponent = component;
      }
      const newModalInstance = {
        component: actualComponent,
        id,
        isOpen: false,
        onBeforeClose: callback => {
          beforeCloseCallbacks.current.set(id, callback);
        },
        close: value => {
          if (canClose(id)) {
            resolve(value);
            closeCurrent(id);
          }
        },
        props,
        index: 0
      };
      setStack(prev => {
        const existingModal = prev.find(modal => modal.id === id);
        if (existingModal) {
          console.error(`Modal with ID "${id}" already exists, and cant be opened`);
          return prev;
        }
        let newStack;
        if (options !== null && options !== void 0 && options.replace && prev.length > 0) {
          newStack = [...prev.slice(0, -1), newModalInstance];
          setAction("replace");
        } else {
          newStack = [...prev, newModalInstance];
          setAction("push");
        }
        return updateModalStack(newStack);
      });
    });
  }, [generateId, updateModalStack, closeById, canClose]);
  const close = useCallback(function () {
    let n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if (typeof n !== "number" || n < 1) {
      throw new Error(`amount must be a number greater than 0. Received ${n}`);
    }
    let closedCount = 0;
    setStack(prev => {
      let newStack = [...prev];
      for (let i = prev.length - 1; i >= 0 && closedCount < n; i--) {
        const modal = prev[i];
        if (canClose(modal.id)) {
          beforeCloseCallbacks.current.delete(modal.id);
          newStack = newStack.filter(m => m.id !== modal.id);
          closedCount += 1;
        }
      }
      if (closedCount > 0) setAction("pop");
      return updateModalStack(newStack);
    });
    return closedCount > 0;
  }, [updateModalStack, canClose]);
  const closeAll = useCallback(() => {
    let wasAnyClosed = false;
    setStack(prev => {
      if (prev.length > 0) {
        wasAnyClosed = true;
        setAction("pop");
        beforeCloseCallbacks.current.clear();
        return [];
      }
      return prev;
    });
    return wasAnyClosed;
  }, []);
  return {
    open,
    close,
    closeById,
    closeAll,
    stack,
    action,
    isLoading
  };
}